export const DISCOUNT_COUPON_APPLIES_TO = {
  ANY: "ANY",
  PLACE_TYPE: "PLACE_TYPE",
  PRODUCT: "PRODUCT",
  RESTAURANT: "RESTAURANT",
};
